import React from "react";
import { motion } from "framer-motion";
import { Globe2, Hammer, Clock, Lightbulb, BookOpen } from "lucide-react";

export const WonderSlide = ({ wonder, index, total }) => {
  return (
    <div className="slide-content" data-testid={`wonder-slide-${wonder.id}`}>
      <div className="max-w-7xl w-full grid grid-cols-1 lg:grid-cols-12 gap-6 px-2">
        {/* LEFT: image */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.55, ease: "easeOut" }}
          className="lg:col-span-7 flex flex-col gap-4"
        >
          <div className="wonder-image-wrap" style={{ height: "min(78vh, 680px)", maxHeight: "min(78vh, 680px)" }}>
            <img
              src={wonder.image}
              alt={wonder.name}
              className="wonder-image"
              loading="lazy"
              data-testid={`wonder-image-${wonder.id}`}
            />
          </div>
        </motion.div>

        {/* RIGHT: details */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.55, ease: "easeOut", delay: 0.1 }}
          className="lg:col-span-5 glass-card p-5 sm:p-6 flex flex-col gap-4"
        >
          <div className="flex items-center gap-2 flex-wrap">
            <span className="tag" style={{ background: wonder.accent, color: "white", borderColor: "transparent" }}>
              Wonder {index} of {total}
            </span>
            <span className="tag">{wonder.flag} {wonder.country}</span>
            <span className="tag"><Globe2 className="w-3.5 h-3.5" />{wonder.continent}</span>
          </div>

          <h2 className="font-heading font-bold text-3xl sm:text-4xl text-slate-900 leading-tight">
            <span className="mr-2">{wonder.emoji}</span>
            {wonder.name}
          </h2>

          <p className="font-body text-base text-slate-700 leading-relaxed">
            {wonder.summary}
          </p>

          <div className="grid grid-cols-2 gap-2">
            <div className="info-pill"><Hammer className="w-4 h-4" /><span className="font-body text-xs">{wonder.builtBy}</span></div>
            <div className="info-pill"><Clock className="w-4 h-4" /><span className="font-body text-xs">{wonder.age}</span></div>
          </div>

          <div className="fun-card yellow">
            <div className="flex items-center gap-2 mb-1">
              <Lightbulb className="w-4 h-4" />
              <span className="font-heading font-bold text-sm uppercase tracking-wide">Fun Fact</span>
            </div>
            <p className="font-body text-sm">{wonder.funFact}</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="fun-card blue">
              <div className="flex items-center gap-2 mb-1">
                <BookOpen className="w-4 h-4" />
                <span className="font-heading font-bold text-sm uppercase tracking-wide">Vocabulary</span>
              </div>
              <p className="font-body text-sm">
                <strong>{wonder.vocabulary.word}</strong> - {wonder.vocabulary.meaning}
              </p>
            </div>
            <div className="fun-card green">
              <div className="flex items-center gap-2 mb-1">
                <Lightbulb className="w-4 h-4" />
                <span className="font-heading font-bold text-sm uppercase tracking-wide">Did You Know?</span>
              </div>
              <p className="font-body text-sm">{wonder.didYouKnow}</p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};
